(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spluss-cart-accessory-upsell"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('spluss-cart-accessory-upsell')) {
    customElements.define(
      'spluss-cart-accessory-upsell',
      class SplussCartAccessoryUpsell extends HTMLElement {
        connectedCallback() {
          this.addEventListener('submit', this.onSubmit);

          if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
              if (event.source !== 'spluss-cart-accessory-upsell') this.refresh();
            });
          }

          requestAnimationFrame(() => this.initializeSlider());
        }

        disconnectedCallback() {
          this.removeEventListener('submit', this.onSubmit);
          if (this.cartUpdateUnsubscriber) this.cartUpdateUnsubscriber();
        }

        onSubmit = async (event) => {
          const form = event.target.closest('[data-upsell-product-form]');
          if (!form) return;

          event.preventDefault();
          const button = form.querySelector('[type="submit"]');
          const spinner = button.querySelector('.loading__spinner');

          button.disabled = true;
          button.classList.add('loading');
          spinner?.classList.remove('hidden');
          this.setStatus('');

          try {
            const mainCartSectionId = document.querySelector('#strix-main-cart')?.dataset.id;
            const sectionIds = [this.dataset.sectionId, mainCartSectionId, 'cart-icon-bubble', 'cart-drawer'].filter(Boolean);
            const formData = new FormData(form);
            formData.set('sections', [...new Set(sectionIds)].join(','));
            formData.set('sections_url', window.location.pathname);

            const response = await fetch(window.routes.cart_add_url, {
              method: 'POST',
              headers: {
                Accept: 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
              },
              body: formData
            });
            const cartState = await response.json();

            if (!response.ok || cartState.status) {
              throw new Error(cartState.description || cartState.message || this.dataset.errorMessage);
            }

            this.replaceSection(cartState.sections?.[mainCartSectionId], '#strix-main-cart');
            this.replaceSection(cartState.sections?.['cart-icon-bubble'], '#shopify-section-cart-icon-bubble');
            this.replaceSection(cartState.sections?.['cart-drawer'], 'cart-drawer');

            const replacement = this.getSectionElement(
              cartState.sections?.[this.dataset.sectionId],
              'spluss-cart-accessory-upsell'
            );

            if (replacement) {
              this.replaceWith(replacement);
              if (typeof replacement.setStatus === 'function') {
                replacement.setStatus(replacement.dataset.successMessage);
              } else {
                const status = replacement.querySelector('[data-upsell-status]');
                if (status) status.textContent = replacement.dataset.successMessage;
              }
            } else {
              this.setStatus(this.dataset.successMessage);
            }
          } catch (error) {
            this.setStatus(error.message || this.dataset.errorMessage, true);
            button.disabled = false;
            button.classList.remove('loading');
            spinner?.classList.add('hidden');
          }
        };

        async refresh() {
          if (this.refreshing) return;
          this.refreshing = true;

          try {
            const url = new URL(window.location.href);
            url.searchParams.set('section_id', this.dataset.sectionId);
            const response = await fetch(url.toString(), {
              headers: { 'X-Requested-With': 'XMLHttpRequest' }
            });
            if (!response.ok) throw new Error(this.dataset.errorMessage);

            const html = await response.text();
            const replacement = this.getSectionElement(html, 'spluss-cart-accessory-upsell');
            if (replacement && this.isConnected) this.replaceWith(replacement);
          } catch (error) {
            this.setStatus(error.message || this.dataset.errorMessage, true);
          } finally {
            this.refreshing = false;
          }
        }

        replaceSection(html, selector) {
          const currentElement = document.querySelector(selector);
          const replacement = this.getSectionElement(html, selector);
          if (currentElement && replacement) currentElement.replaceWith(replacement);
        }

        getSectionElement(html, selector) {
          if (!html) return null;
          return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
        }

        initializeSlider() {
          const sliderId = this.dataset.upsellSliderId;
          const slider = this.querySelector(`[data-slider-id="${sliderId}"]`);
          if (!slider || slider.dataset.sliderEnabled === 'true' || !window.initSliders) return;

          window.initSliders(false, `[data-slider-id="${sliderId}"]`);
        }

        setStatus(message, isError = false) {
          const status = this.querySelector('[data-upsell-status]');
          if (!status) return;
          status.textContent = message;
          status.setAttribute('aria-live', isError ? 'assertive' : 'polite');
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spluss-filterable-blog"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('blog-metaobject-filter')) {
    class BlogMetaobjectFilter extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;

        this.initialized = true;
        this.paramName = 'blog_filter';
        this.sectionId = this.dataset.sectionId;
        this.pageParam = this.dataset.pageParam || 'page';
        this.articleList = this.querySelector('[data-article-list]');
        this.pagination = this.querySelector('[data-pagination]');
        this.noResults = this.querySelector('[data-no-results]');
        this.loadingStatuses = Array.from(this.querySelectorAll('[data-loading-status]'));
        this.boundChange = this.handleChange.bind(this);
        this.boundClick = this.handleClick.bind(this);
        this.boundPopState = this.handlePopState.bind(this);

        this.addEventListener('change', this.boundChange);
        this.addEventListener('click', this.boundClick);
        window.addEventListener('popstate', this.boundPopState);

        this.initialize();
      }

      disconnectedCallback() {
        this.removeEventListener('change', this.boundChange);
        this.removeEventListener('click', this.boundClick);
        window.removeEventListener('popstate', this.boundPopState);
      }

      async initialize() {
        this.syncInputsFromUrl();
        const renderedArticleCount = this.querySelectorAll('[data-article]').length;
        const requiresAggregation =
          Number(this.dataset.currentPage) > 1 || Number(this.dataset.totalArticles) > renderedArticleCount;
        this.setFilteringDisabled(requiresAggregation);

        const loadedAllArticles = await this.loadAllPages();

        this.articles = Array.from(this.querySelectorAll('[data-article]'));
        this.updateFilterCounts();

        if (!loadedAllArticles) {
          this.classList.add('filterable-blog--load-failed');
          this.updateResultCounts(this.articles.length, Number(this.dataset.totalArticles));
          this.removeAttribute('aria-busy');
          this.setLoadingMessage();
          return;
        }

        this.pagination?.setAttribute('hidden', '');
        this.setFilteringDisabled(false);
        this.hideLoadingStatuses();
        this.applyFilters(false);
      }

      async loadAllPages() {
        let nextUrl = this.dataset.nextUrl;
        const visitedUrls = new Set();
        let stagedArticles = Array.from(this.querySelectorAll('[data-article]'));

        if (Number(this.dataset.currentPage) > 1) {
          const firstPageUrl = new URL(window.location.href);
          firstPageUrl.searchParams.delete(this.pageParam);
          const firstPageSection = await this.fetchSection(firstPageUrl.toString());

          if (!firstPageSection) return false;

          stagedArticles = Array.from(firstPageSection.querySelectorAll('[data-article]'));
          nextUrl = firstPageSection.dataset.nextUrl || '';
        }

        while (nextUrl) {
          if (visitedUrls.has(nextUrl)) return false;
          visitedUrls.add(nextUrl);

          const responseSection = await this.fetchSection(nextUrl);
          if (!responseSection) return false;

          const existingIds = new Set(stagedArticles.map((article) => article.dataset.articleId));

          responseSection.querySelectorAll('[data-article]').forEach((article) => {
            if (existingIds.has(article.dataset.articleId)) return;
            existingIds.add(article.dataset.articleId);
            stagedArticles.push(article);
          });

          nextUrl = responseSection.dataset.nextUrl || '';
        }

        this.articleList.replaceChildren(...stagedArticles);
        return true;
      }

      async fetchSection(url) {
        try {
          const requestUrl = new URL(url, window.location.origin);
          requestUrl.searchParams.set('section_id', this.sectionId);

          const response = await fetch(requestUrl.toString(), {
            headers: {
              'X-Requested-With': 'XMLHttpRequest',
            },
          });

          if (!response.ok) return null;

          const responseText = await response.text();
          const parsedDocument = new DOMParser().parseFromString(responseText, 'text/html');
          return parsedDocument.querySelector('blog-metaobject-filter');
        } catch {
          return null;
        }
      }

      handleChange(event) {
        const input = event.target.closest('[data-blog-filter-input]');
        if (!input) return;

        this.querySelectorAll('[data-blog-filter-input]').forEach((candidate) => {
          if (candidate.value === input.value) candidate.checked = input.checked;
        });

        this.applyFilters(true);
      }

      handleClick(event) {
        const removeButton = event.target.closest('[data-remove-filter]');
        const clearButton = event.target.closest('[data-clear-filters]');
        const applyButton = event.target.closest('[data-apply-filters]');

        if (removeButton) {
          event.preventDefault();
          const filter = removeButton.dataset.removeFilter;
          this.querySelectorAll('[data-blog-filter-input]').forEach((input) => {
            if (input.value === filter) input.checked = false;
          });
          this.applyFilters(true);
          return;
        }

        if (clearButton) {
          event.preventDefault();
          this.querySelectorAll('[data-blog-filter-input]').forEach((input) => {
            input.checked = false;
          });
          this.applyFilters(true);
          return;
        }

        if (applyButton) {
          event.preventDefault();
          this.closeMobileDrawer(applyButton);
        }
      }

      handlePopState() {
        this.syncInputsFromUrl();
        this.applyFilters(false);
      }

      getSelectedFilters() {
        return Array.from(
          new Set(
            Array.from(this.querySelectorAll('[data-blog-filter-input]:checked')).map((input) => input.value)
          )
        );
      }

      getFilterLabel(filter) {
        const matchingInput = Array.from(this.querySelectorAll('[data-blog-filter-input]')).find(
          (input) => input.value === filter
        );
        return matchingInput?.dataset.filterLabel || filter;
      }

      getSelectedFilterGroups(selectedFilters) {
        const selectedFilterSet = new Set(selectedFilters);
        const selectedGroups = new Map();

        this.querySelectorAll('[data-blog-filter-input]').forEach((input) => {
          if (!selectedFilterSet.has(input.value)) return;

          const group = input.dataset.filterGroup;
          if (!selectedGroups.has(group)) selectedGroups.set(group, new Set());
          selectedGroups.get(group).add(input.value);
        });

        return selectedGroups;
      }

      syncInputsFromUrl() {
        const selectedFilters = new Set(new URL(window.location.href).searchParams.getAll(this.paramName));

        this.querySelectorAll('[data-blog-filter-input]').forEach((input) => {
          input.checked = selectedFilters.has(input.value);
        });
      }

      applyFilters(updateUrl) {
        if (!this.articles) return;

        const selectedFilters = this.getSelectedFilters();
        const selectedFilterGroups = this.getSelectedFilterGroups(selectedFilters);
        const articleStates = this.articles.map((article) => {
          const articleFilters = this.getArticleFilters(article);
          return {
            article,
            isVisible:
              selectedFilterGroups.size === 0 ||
              Array.from(selectedFilterGroups.values()).every((groupFilters) =>
                articleFilters.some((articleFilter) => groupFilters.has(articleFilter))
              ),
          };
        });
        const visibleCount = articleStates.filter((state) => state.isVisible).length;

        const updateArticles = () => {
          articleStates.forEach((state) => {
            state.article.hidden = !state.isVisible;
          });
          this.noResults.hidden = visibleCount !== 0;
        };

        const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        if (document.startViewTransition && !prefersReducedMotion) {
          document.startViewTransition(updateArticles);
        } else {
          updateArticles();
        }

        this.updateResultCounts(visibleCount, this.articles.length);
        this.renderActiveFacets(selectedFilters);

        if (updateUrl) this.updateUrl(selectedFilters);
      }

      getArticleFilters(article) {
        try {
          const filters = JSON.parse(article.dataset.articleFilters || '[]');
          return Array.isArray(filters) ? filters : [];
        } catch {
          return [];
        }
      }

      updateFilterCounts() {
        const counts = new Map();

        this.articles.forEach((article) => {
          this.getArticleFilters(article).forEach((filter) => {
            counts.set(filter, (counts.get(filter) || 0) + 1);
          });
        });

        this.querySelectorAll('[data-filter-count]').forEach((countElement) => {
          const count = counts.get(countElement.dataset.filterCount) || 0;
          countElement.textContent = `(${count})`;
          countElement.closest('[data-filter-option-item]')?.toggleAttribute('hidden', count === 0);
        });

        this.querySelectorAll('[data-filter-group-panel]').forEach((panel) => {
          const hasVisibleOptions = panel.querySelector('[data-filter-option-item]:not([hidden])') !== null;
          panel.toggleAttribute('hidden', !hasVisibleOptions);
        });
      }

      updateResultCounts(visibleCount, totalCount) {
        const countText = this.dataset.countTemplate
          .replace('__VISIBLE__', String(visibleCount))
          .replace('__TOTAL__', String(totalCount));

        this.querySelectorAll('[data-result-count]').forEach((countElement) => {
          countElement.textContent = countText;
        });
      }

      renderActiveFacets(selectedFilters) {
        const filterTemplate = this.querySelector('[data-active-filter-template]');
        const clearTemplate = this.querySelector('[data-clear-filters-template]');

        this.querySelectorAll('[data-active-facets]').forEach((container) => {
          container.replaceChildren();
          container.hidden = selectedFilters.length === 0;

          selectedFilters.forEach((filter) => {
            const filterLabel = this.getFilterLabel(filter);
            const filterButton = filterTemplate.content.firstElementChild.cloneNode(true);
            filterButton.dataset.removeFilter = filter;
            filterButton.querySelector('[data-active-filter-label]').textContent = filterLabel;
            filterButton.querySelector('[data-remove-filter-label]').textContent = this.dataset.removeTemplate.replace(
              '__TAG__',
              filterLabel
            );
            container.append(filterButton);
          });

          if (selectedFilters.length > 0) {
            container.append(clearTemplate.content.firstElementChild.cloneNode(true));
          }
        });
      }

      updateUrl(selectedFilters) {
        const url = new URL(window.location.href);
        url.searchParams.delete(this.paramName);
        url.searchParams.delete(this.pageParam);
        selectedFilters.forEach((filter) => url.searchParams.append(this.paramName, filter));
        window.history.pushState({ blogFilters: selectedFilters }, '', url);
      }

      setFilteringDisabled(disabled) {
        this.querySelectorAll('[data-blog-filter-input], [data-clear-filters], [data-apply-filters]').forEach((control) => {
          control.toggleAttribute('disabled', disabled);
        });
        this.toggleAttribute('aria-busy', disabled);
      }

      setLoadingMessage() {
        this.loadingStatuses.forEach((status) => {
          status.hidden = false;
          status.textContent = this.dataset.loadErrorTemplate;
        });
      }

      hideLoadingStatuses() {
        this.loadingStatuses.forEach((status) => {
          status.hidden = true;
        });
        this.removeAttribute('aria-busy');
      }

      closeMobileDrawer(control) {
        const drawer = control.closest('menu-drawer');
        const mainDetails = drawer?.querySelector(':scope > details');
        const summary = mainDetails?.querySelector(':scope > summary');

        if (mainDetails?.open && summary) summary.click();
      }
    }

    customElements.define('blog-metaobject-filter', BlogMetaobjectFilter);
  }

  } catch(e) { console.error(e); }
})();
})();
